import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import ProjectBlurb from '../project-blurb';
import Reveal from '../../reveal';
import StaggeredCardFade from '../../animations/staggered-card-fade';
import { css } from 'emotion';
import styles from './project-print-ads.module.css';

const AdCard = props => {
  const { card, key, animation, img } = props;
  return (
    <div key={key} className={styles.page} style={animation}>
      <Img
        sizes={card.image.localFile.childImageSharp.sizes}
        backgroundColor={true}
        alt={'Print'}
      />
    </div>
  );
};

const PrintAdsContent = props => {
  const { images, blurb, wrapperPadding, isInView } = props;
  const renderImages = () => {
    return images.map((card, index) => {
      return (
        <StaggeredCardFade
          delay={index === 0 ? 400 : 800}
          isInView={isInView}
          key={index}
        >
          <AdCard card={card} />
        </StaggeredCardFade>
      );
    });
  };
  return (
    <div
      className={css`
        padding: ${wrapperPadding};
      `}
    >
      <div className={styles.imageWrapper}>{renderImages()}</div>
      <ProjectBlurb blurb={blurb} />
    </div>
  );
};

const ProjectPrintAds = props => {
  return (
    <Reveal>
      <PrintAdsContent {...props} />
    </Reveal>
  );
};

AdCard.propTypes = {
  card: PropTypes.object,
};

PrintAdsContent.propTypes = {
  images: PropTypes.array,
  blurb: PropTypes.string,
  wrapperPadding: PropTypes.string,
  isInView: PropTypes.bool,
};

export default ProjectPrintAds;



// WEBPACK FOOTER //
// ./src/components/project/project-print-ads/index.js